import { webKnots } from 'src/features/brands/atoms/canvas/common/back/lace/webKnots'
import { lacePartsOfWeb1, lacePartsOfWeb2, lacePartsOfWeb3, upLeftDownRight2, upRightDownLeft, upRightDownLeft3 } from './parts/laceParts'
import { verticalPartsOfWebCircleEndWithEdge2 } from './parts/verticalParts'

export const lacingWeb1 = (ctx: CanvasRenderingContext2D, webColor: string, edgeColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor

  // 縦パーツ
  verticalPartsOfWebCircleEndWithEdge2(ctx, webColor, edgeColor, laceColor, stitchColor)
  // laceここから
  lacePartsOfWeb3(ctx, laceColor, -11, -38, 1, 1.05)
  lacePartsOfWeb1(ctx, laceColor, -3, 2, 0, 1)
  lacePartsOfWeb1(ctx, laceColor, -20, 34, 0, 1)
  lacePartsOfWeb1(ctx, laceColor, -38, 64, 0, 1)
  lacePartsOfWeb1(ctx, laceColor, -23, 92, 1, 0.95)
  lacePartsOfWeb1(ctx, laceColor, -8, 132, 1, 0.9)
  upRightDownLeft(ctx, laceColor, 0, 0)

  laceOfWebTop3(ctx, laceColor)
  upRightDownLeft3(ctx, laceColor, 40, -60)
  lacePartsOfWeb2(ctx, laceColor, -51, -43, -1, 1.11)
  lacePartsOfWeb2(ctx, laceColor, -51, -15, -1, 1.08)
  lacePartsOfWeb2(ctx, laceColor, -23, 27, -1, 1)
  lacePartsOfWeb2(ctx, laceColor, -12, 62, -1, 0.95)
  lacePartsOfWeb2(ctx, laceColor, 4, 102, -1, 0.9)
  upLeftDownRight2(ctx, laceColor)

  // 先端の革紐
  laceOfWebTop2(ctx, laceColor)
  laceOfWebTop1(ctx, laceColor, 98, 151)
  laceOfWebTop1(ctx, laceColor, 95, 135)
  laceOfWebTop1(ctx, laceColor, 90, 123)
  laceOfWebTop1(ctx, laceColor, 86, 110)

  laceOfWebTop1(ctx, laceColor, 77, 85)
  laceOfWebTop1(ctx, laceColor, 72, 77)
  laceOfWebTop1(ctx, laceColor, 66, 68)
  laceOfWebTop1(ctx, laceColor, 60, 63)

  laceOfWebTop0(ctx, laceColor, -18, -20)
  laceOfWebTop0(ctx, laceColor, 0, 0)
  laceOfWebTop0(ctx, laceColor, 18, 18)
  laceOfWebTop1(ctx, laceColor, 5, 5)
  laceOfWebTop1(ctx, laceColor, 0, 2)
  laceOfWebTop1(ctx, laceColor, -5, -1)
  laceOfWebTop1(ctx, laceColor, -10, -5)

  laceOfWebTop1(ctx, laceColor, -20, -15)
  laceOfWebTop1(ctx, laceColor, -28, -23)
  laceOfWebTop1(ctx, laceColor, -36, -29)
  laceOfWebTop1(ctx, laceColor, -44, -36)

  webKnots(ctx, laceColor, -105, 115) // 捕球面折り返し上
  ctx.strokeStyle = '#282828'
}

const laceOfWebTop0 = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number) => {
  ctx.lineWidth = 0.8
  ctx.fillStyle = laceColor
  ctx.strokeStyle = '#282828'
  // 左上→右下
  ctx.beginPath()
  ctx.moveTo(650 + x, 121 + y) //左上
  ctx.quadraticCurveTo(645 + x, 127 + y, 645 + x, 129 + y) //左下
  ctx.quadraticCurveTo(654 + x, 133 + y, 663 + x, 146 + y) // 右下
  ctx.quadraticCurveTo(667 + x, 141 + y, 667 + x, 138 + y) // 右上
  ctx.quadraticCurveTo(661 + x, 124 + y, 650 + x, 121 + y) // 左上
  ctx.fill()
  ctx.moveTo(646 + x, 128 + y) //左下
  ctx.quadraticCurveTo(654 + x, 129 + y, 664 + x, 145 + y) //中間1_下
  ctx.stroke()
  ctx.closePath()
}
const laceOfWebTop1 = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number) => {
  ctx.lineWidth = 0.8
  ctx.fillStyle = laceColor
  ctx.strokeStyle = '#282828' //
  // 左上→右下
  ctx.beginPath()
  ctx.moveTo(621 + x, 90 + y) //左上
  ctx.quadraticCurveTo(627 + x, 95 + y, 619 + x, 100 + y) //左下
  ctx.quadraticCurveTo(617 + x, 106 + y, 622 + x, 107 + y) //右下
  ctx.quadraticCurveTo(630 + x, 105 + y, 632 + x, 98 + y) //右上
  ctx.quadraticCurveTo(632 + x, 84 + y, 621 + x, 90 + y) //左上
  ctx.fill()
  ctx.moveTo(623 + x, 90 + y) //左下
  ctx.quadraticCurveTo(631 + x, 95 + y, 618 + x, 102 + y) //中間1_下
  ctx.stroke()
  ctx.closePath()
}

const laceOfWebTop2 = (ctx: CanvasRenderingContext2D, laceColor: string) => {
  ctx.lineWidth = 0.8
  ctx.fillStyle = laceColor
  ctx.strokeStyle = '#282828' //
  // 左上→右下
  ctx.beginPath()
  ctx.moveTo(554, 43) //左上
  ctx.quadraticCurveTo(547, 43, 551, 53) //左下
  ctx.quadraticCurveTo(580, 63, 611, 94) //右下
  ctx.quadraticCurveTo(615, 90, 613, 85) //右上
  ctx.quadraticCurveTo(581, 53, 554, 43) //左上
  ctx.fill()
  ctx.moveTo(551, 50) //左下
  ctx.quadraticCurveTo(565, 55, 576, 63) //中間1_下
  ctx.stroke()
  ctx.closePath()
}

const laceOfWebTop3 = (ctx: CanvasRenderingContext2D, laceColor: string) => {
  ctx.lineWidth = 0.8
  ctx.fillStyle = laceColor
  ctx.strokeStyle = '#282828' //
  // 左上→右下
  ctx.beginPath()
  ctx.moveTo(697, 169) //左上
  ctx.quadraticCurveTo(689, 175, 689, 175) //左下
  ctx.quadraticCurveTo(714, 227, 721, 273) //右下
  ctx.quadraticCurveTo(726, 274, 727, 268) //右上
  ctx.quadraticCurveTo(712, 209, 697, 169) //左上
  ctx.fill()
  // ctx.moveTo(551, 50) //左下
  // ctx.quadraticCurveTo(565, 55, 576, 63) //中間1_下
  ctx.stroke()
  ctx.closePath()
}
